import { useState, useEffect } from "react";
import { useUsers } from "../../contexts/UsersContext";
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from "@headlessui/react"; 
import axios from "axios";
import { getToken } from "../../utils/tokenUtils";

// const UserSelector = ({ formData, setFormData }) => {
//     const { users } = useUsers();
//     const [query, setQuery] = useState("");

//     // // console.log("list users: ", users);

//     const filteredUsers = users.filter(user =>
//         user.name.toLowerCase().includes(query.toLowerCase())
//     );

    // const handleSelection = (selectedUser) => {
    //     if (!selectedUser) {
    //         // console.log("Selection cleared");
    //         setFormData({ ...formData, id: null });
    //         return;
    //     }

    //     // console.log("Selected user: ", selectedUser, "selected user id", selectedUser.id);
    //     setFormData({ ...formData, id: selectedUser.id });
    // };

//     return (
        // <Combobox value={formData.id} onChange={handleSelection}>
        //     <div className="relative">
        //         <ComboboxInput
        //             id="userId"
        //             onChange={(event) => setQuery(event.target.value)}
        //             displayValue={(userId) => {
        //                 const selected = users.find(c => c.id === userId);
        //                 return selected ? selected.name : "";
        //             }}
        //             className="w-full p-2 border border-gray-300 rounded"
        //             placeholder="Select a user"
        //         />
        //         <ComboboxOptions className="absolute w-full bg-white border border-gray-300 rounded mt-1 max-h-60 z-20 overflow-auto">
        //             {filteredUsers.length === 0 ? (
        //                 <div className="p-2 text-gray-500">No users found</div>
        //             ) : (
        //                 filteredUsers.map((user) => (
        //                     <ComboboxOption key={user.id} value={user} className="p-2 hover:bg-gray-200 cursor-pointer">
        //                         {user.name}
        //                     </ComboboxOption>
        //                 ))
        //             )}
        //         </ComboboxOptions>
        //     </div>
        // </Combobox>
//     );
// };

// export default UserSelector;


const UserSelector = ({ formData, setFormData}) => {
    const [query, setQuery] = useState("");
    const [users, setUsers] = useState([]);
    const token = getToken()
    
    const filteredUsers = users.filter(user =>
        user.name.toLowerCase().includes(query.toLowerCase())
    );

    // fetching user on mount
    useEffect(() => {
        const fetchUsers = async () => {
            try {
            const res = await axios.get(`https://hrmsnew.prepstripe.com/api/users-with-employee-ids`, {
                headers: {
                    contentType: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }); // update with actual endpoint
            setUsers(res.data);
            } catch (error) {
            console.error("Failed to fetch users:", error);
            }
        };
    
        fetchUsers();
    }, [token]);

    const handleSelection = (selectedUser) => {
        if (!selectedUser) {
            // console.log("Selection cleared");
            setFormData({ ...formData, id: null });
            return;
        }

        // console.log("Selected user: ", selectedUser, "selected user id", selectedUser.id);
        setFormData({ ...formData, id: selectedUser.id });
    };

    return (
        <Combobox value={formData.id} onChange={handleSelection}>
            <div className="relative">
                <ComboboxInput
                    id="userId"
                    onChange={(event) => setQuery(event.target.value)}
                    displayValue={(userId) => {
                        const selected = users.find(c => c.id === userId);
                        return selected ? selected.name : "";
                    }}
                    className="w-full p-2 dark:bg-black dark:text-white dark:border-gray-700 border border-gray-300 rounded"
                    placeholder="Select a user"
                />
                <ComboboxOptions className="absolute w-full dark:bg-black bg-white border border-gray-300 rounded mt-1 max-h-60 z-20 overflow-auto">
                    {filteredUsers.length === 0 ? (
                        <div className="p-2 text-gray-500">No users found</div>
                    ) : (
                        filteredUsers.map((user) => (
                            <ComboboxOption key={user.id} value={user} className="p-2 dark:bg-black hover:bg-gray-200 cursor-pointer">
                                {user.name}
                            </ComboboxOption>
                        ))
                    )}
                </ComboboxOptions>
            </div>
        </Combobox>
    );
};

export default UserSelector;
